import * as api from './provider-api'
import {
    deepCopy,
    timeFilter
} from '@/untils/untils.js'
import XLSX from 'xlsx'
export default {
    data() {
        return {

            // header
            isMobileFlag: JSON.parse(localStorage.getItem('isMobileFlag')),
            // table
            tableData: [],
            pageSize: 10,
            currPage: 1,
            total: 0,
            exporting: false,
            /* 修改flag */
            editFlag: false,
            // dialog
            dialogVisible: false,
            typeDialogVisible: false, //供应商分类
            natureDialogVisible: false, //供应商性质
            brandDialogVisible: false, //供应商性质
            dialogInfo: {
                tsName: '', //供应商名字
                tsTel: '', //供应商联系方式
                tsNumber: '', //供应商人数
                tsEmail: '', //供应商邮箱
                tsCapital: '', //供应商资金
                tsContacts: '', //联系人
                tsCustom: '', //主营业务
                supplierTagList: [], //供应商类别,
                supplierBrandList: [], //品牌
                supplierNatureList: [], //性质
                tsBusinessLicense: '', //营业执照图片
                supplierQualificationList: [], //营业执照号
            },
            rulesList: {
                tsName: [{
                    required: true,
                    message: '请输入供应商名称',
                    trigger: ['blur', 'change']
                },],
                tsEmail: [{
                    required: true,
                    message: '请输入邮箱',
                    trigger: ['blur', 'change']
                }],
                tsTel: [{
                    required: true,
                    message: '请输入联系方式',
                    trigger: ['blur', 'change']
                }],
                tsBusinessLicense: [{
                    required: true,
                    message: '请上传营业执照图片',
                    trigger: ['blur', 'change']
                }],
            },
            /* supplierType */
            SupplierTypeList: [],
            SupplierTypeInfo: {
                ckey: '',
                cvalue: '',
            },

            /* supplierNature */
            SupplierNatureList: [],
            SupplierNatureInfo: {
                ckey: '',
                cvalue: '',
            },

            /* supplierNature */
            SupplierBrandList: [],
            SupplierBrandInfo: {
                ckey: '',
                cvalue: '',
            },
            /* 关键词搜索 */
            queryInfo: {
                tsName: '', //搜索关键词  供应商名字
                tsContacts: '', //搜索关键词  联系人
                tsTagList: [], //供应商类别,
                tsBrandList: [], //品牌
                tsNatureList: [], //性质
            },


        }
    },
    filters: {
        handleTags(val, key) {
            console.log(val);
            return val.reduce((res, cur) => {
                console.log(res, cur);
                return res += ',' + cur[key]
            }, '')
        }
    },
    watch: {
        pageSize(val) {
            this.currPage = 1
            this.findSupplier()
        },
    },
    computed: {
        title(val) {
            console.log(this.editFlag);
            if (!this.editFlag) return '添加供应商'
            return '修改供应商'
        },
    },
    mounted() {
        this.findSupplier()
        this.findSupplierTypeTag()
        this.findSupplierNature()
        this.findSupplierBrand()
    },
    methods: {

        /* api */
        prePage() { // 查

        },
        /* 新增供应商 */
        addSupplier() {

            api.addSupplier(this.dialogInfo).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findSupplier()
                }
            })
        },
        /* 删除供应商 */
        deleteSupplier(data) {
            api.deleteSupplier(data).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findSupplier()
                }
            })
        },
        /* 查询供应商 */
        findSupplier() {
            api.findSupplier({
                currPage: this.currPage,
                pageSize: this.pageSize,
                ...this.queryInfo
            }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.tableData = d.dataList
                    this.total = d.totalCount
                }
            })
        },
        /* 修改供应商 */
        updateSupplier() {
            api.updateSupplier(this.dialogInfo).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findSupplier()
                }
            })
        },

        /* 查询供应商类别标签 */
        findSupplierTypeTag(findType) {
            api.findSupplierTypeTag({
                findType
            }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.SupplierTypeList = d
                }
            })
        },

        /* 新增供应商类别标签 */
        addSupplierTypeTag() {
            api.addSupplierTypeTag(this.SupplierTypeInfo).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findSupplierTypeTag(1)
                    this.SupplierTypeInfo.cvalue = ''
                }
            })
        },

        /* 删除供应商类别标签 */
        deleteSupplierTypeTag(params) {
            api.deleteSupplierTypeTag(params).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findSupplierTypeTag(1)
                }
            })
        },

        /* 查询供应商性质标签 */
        findSupplierNature(findType) {
            api.findSupplierNature({
                findType
            }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.SupplierNatureList = d
                }
            })
        },

        /* 新增供应商性质标签 */
        addSupplierNature() {
            api.addSupplierNature(this.SupplierNatureInfo).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findSupplierNature(1)
                    this.SupplierNatureInfo.cvalue = ''
                }
            })
        },

        /* 删除供应商品牌标签 */
        deleteSupplierNature(params) {
            api.deleteSupplierNature(params).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findSupplierNature(1)
                }
            })
        },


        /* 查询供应商品牌标签 */
        findSupplierBrand(findType) {
            api.findSupplierBrand({
                findType
            }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.SupplierBrandList = d
                }
            })
        },

        /* 新增供应商品牌标签 */
        addSupplierBrand() {
            api.addSupplierBrand(this.SupplierBrandInfo).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findSupplierBrand(1)
                    this.SupplierBrandInfo.cvalue = ''
                }
            })
        },

        /* 删除供应商性质标签 */
        deleteSupplierBrand(params) {
            api.deleteSupplierBrand(params).then(data => {
                if (data) {
                    this.$message.success('操作成功')
                    this.findSupplierBrand(1)
                }
            })
        },


        /* handle */
        /* 关键词搜索 */
        queryInfoByKeyword() {
            this.currPage = 1
            this.findSupplier()
        },
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {

                    const {
                        supplierNatureList,
                        supplierTagList,
                        supplierBrandList
                    } = this.dialogInfo
                    console.log(supplierNatureList);
                    this.dialogInfo.supplierNatureList = supplierNatureList.map(t => ({
                        tsNature: t
                    }))

                    this.dialogInfo.supplierTagList = supplierTagList.map(t => ({
                        tsTag: t
                    }))

                    this.dialogInfo.supplierBrandList = supplierBrandList.map(t => ({
                        tsBrand: t
                    }))

                    this.editFlag ? this.updateSupplier() : this.addSupplier()
                    this.dialogVisible = false
                }
            })

        },

        uploadLicense(file) {
            // 仅支持图片文件
            let type = '.' + file.name.split('.').pop()
            if (type !== '.jpg' && type !== '.jpeg' && type !== '.png' && type !== '.gif') {
                this.$message.warning('仅支持上传图片文件')
                this.fileList = []
                return
            }

            const formData = new FormData()
            formData.append('file', file)

            api.filesUpload(formData).then(data => {
                if (data) {
                    this.dialogInfo.tsBusinessLicense = data.data.resultObject
                }
            })
        },

        uploadQualification(file) {
            // 仅支持图片文件
            let type = '.' + file.name.split('.').pop()
            if (type !== '.jpg' && type !== '.jpeg' && type !== '.png' && type !== '.gif') {
                this.$message.warning('仅支持上传图片文件')
                this.fileList = []
                return
            }

            const formData = new FormData()
            formData.append('file', file)

            api.filesUpload(formData).then(data => {
                if (data) {
                    this.dialogInfo.supplierQualificationList.push({
                        tsMaterial: data.data.resultObject
                    })
                }
            })
        },

        openDetailDialog() {
            this.findSupplierTypeTag()
            this.findSupplierNature()
            this.findSupplierBrand()
        },
        closeDetailDialog() {
            this.editFlag = false
            this.dialogInfo = {
                tsName: '', //供应商名字
                tsTel: '', //供应商联系方式
                tsNumber: '', //供应商人数
                tsEmail: '', //供应商邮箱
                tsCapital: '', //供应商资金
                tsContacts: '', //联系人
                tsCustom: '', //主营业务
                supplierTagList: [], //供应商类别,
                supplierBrandList: [], //品牌
                supplierNatureList: [], //性质
                tsBusinessLicense: '', //营业执照
                supplierQualificationList: [], //资质
            }
        },
        openModify(row) {
            this.dialogVisible = true
            this.editFlag = true
            this.dialogInfo = deepCopy({
                ...row,
                tsBusinessLicense: row.tsBusinessLicense || '',
                supplierQualificationList: row.supplierQualificationList || []
            })
            const {
                supplierNatureList,
                supplierTagList,
                supplierBrandList
            } = this.dialogInfo
            this.dialogInfo.supplierNatureList = supplierNatureList.map(t => t.tsNature)
            this.dialogInfo.supplierTagList = supplierTagList.map(t => t.tsTag)
            this.dialogInfo.supplierBrandList = supplierBrandList.map(t => t.tsBrand)
            
            console.log(row)
        },
        deleteThis(row) {
            this.deleteSupplier(row)
        },

        /* 供应商类别弹出框 */
        addSupplierType() {
            let {
                cvalue
            } = this.SupplierTypeInfo
            if (!cvalue) return this.$message('请先输入供应商类别')
            this.SupplierTypeInfo.ckey = this.SupplierTypeList.length + 1
            this.addSupplierTypeTag()
        },
        deleteSupplierType(row) {
            this.deleteSupplierTypeTag(row)
        },
        openTypeDialog() {
            this.findSupplierTypeTag(1)
        },
        closeTypeDialog() {
            this.SupplierTypeInfo = {
                ckey: '',
                cvalue: ''
            }
            this.findSupplierTypeTag()
        },

        /* 供应商性质弹出框 */
        addSupplierNatureTag() {
            let {
                cvalue
            } = this.SupplierNatureInfo
            if (!cvalue) return this.$message('请先输入供应商类别')
            this.SupplierNatureInfo.ckey = this.SupplierNatureList.length + 1
            this.addSupplierNature()
        },
        deleteSupplierNatureTag(row) {
            this.deleteSupplierNature(row)
        },
        openNatureDialog() {
            this.findSupplierNature(1)
        },
        closeNatureDialog() {
            this.SupplierNatureInfo = {
                ckey: '',
                cvalue: ''
            }
            this.findSupplierNature()
        },

        /* 供应商品牌弹出框 */
        addSupplierBrandTag() {
            let {
                cvalue
            } = this.SupplierBrandInfo
            if (!cvalue) return this.$message('请先输入供应商类别')
            this.SupplierBrandInfo.ckey = this.SupplierBrandList.length + 1
            console.log(this.SupplierBrandInfo);
            this.addSupplierBrand()
        },
        deleteSupplierBrandTag(row) {
            this.deleteSupplierBrand(row)
        },
        openBrandDialog() {
            this.findSupplierBrand(1)
        },
        closeBrandDialog() {
            this.SupplierBrandInfo = {
                ckey: '',
                cvalue: ''
            }
            this.findSupplierBrand()
        },


        handleCurPageChange(val) {
            this.currPage = val
            this.findSupplier()
        },
        // 索引
        indexMethod(index) {
            return (this.currPage - 1) * this.pageSize + index + 1
        },

        exportToExcel() { // 导出
            this.exporting = true
            this.$nextTick(() => {
                let workbook = XLSX.utils.table_to_book(this.$refs.table.$el)
                XLSX.writeFile(workbook, `供应商信息-${timeFilter(new Date())}.xlsx`);
                this.exporting = false
            })
        },
    },
}